import React, { createContext, useContext, useState, useCallback } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('sf_user')); } catch { return null; }
  });
  const [settings, setSettings] = useState({});

  const login = useCallback(async (email, password) => {
    const { data } = await api.post('/api/auth/login', { email, password });
    localStorage.setItem('sf_token', data.token);
    localStorage.setItem('sf_user', JSON.stringify(data.user));
    setUser(data.user);
    // Load feature flags
    const { data: s } = await api.get('/api/settings');
    setSettings(s);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('sf_token');
    localStorage.removeItem('sf_user');
    setUser(null);
    setSettings({});
  }, []);

  const loadSettings = useCallback(async () => {
    try {
      const { data } = await api.get('/api/settings');
      setSettings(data);
    } catch {}
  }, []);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get('/api/auth/me');
      localStorage.setItem('sf_user', JSON.stringify(data.user));
      setUser(data.user);
    } catch {}
  }, []);

  const can = useCallback((roles) => {
    if (!user) return false;
    return roles.includes(user.role);
  }, [user]);

  const isAdmin   = user?.role === 'admin';
  const isManager = ['admin','manager'].includes(user?.role);

  return (
    <AuthContext.Provider value={{ user, settings, login, logout, loadSettings, refreshUser, can, isAdmin, isManager }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
